// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientManagementStyles_container__231O2","content":"PatientManagementStyles_content__25MUJ"};